import { Button, Form, Input, Radio, Col, Modal, Row } from "antd";
import React, { useContext, useEffect } from "react";
import SelectAllType from "../../../../../../components/SelectAllType";
import UserContext from "../../../../../../contexts/user.context";
import { _ } from "../../../../../../utils/index";
import SelectDepartments from "./SelectDepartments";
import SelectDivision from "./SelectDivision";
import SelectPosition from "./SelectPosition";
import SelectAddressMaster from "../../../../../../components/SelectAddressMaster";

const FormUser = (props) => {
  const { state, dispatch } = useContext(UserContext);
  const { form } = props;
  const { getFieldDecorator, getFieldValue } = props.form;

  useEffect(() => {
    if (state.form.address) {
      props.form.setFieldsValue({
        address: state.form.address,
        province_id: state.form.province_id,
        district_id: state.form.district_id,
        sub_district_id: state.form.sub_district_id,
        post_code: state.form.post_code,
        // อัปเดตฟิลด์อื่น ๆ ด้วยตามต้องการ
      });
    }
  }, [state.form.address]);

  return (
    <Form
      wrapperCol={{ md: 14 }}
      labelCol={{ md: 10 }}
      labelAlign="right"
      autoComplete="off"
    >
      <Form.Item label="รหัสผนักงาน" className="mb-0">
        {getFieldDecorator("code", {
          rules: [
            {
              required: true,
              message: "กรุณากรอกรหัสผนักงาน",
            },
          ],
          initialValue: state.form.code,
        })(<Input placeholder="รหัสผนักงาน" />)}
      </Form.Item>
      <Form.Item label="ชื่อผู้ใช้งาน" className="mb-0">
        {getFieldDecorator("user_name", {
          rules: [
            {
              required: true,
              message: "กรุณากรอกชื่อผู้ใช้งาน",
            },
          ],
          initialValue: state.form.user_name,
        })(<Input placeholder="ชื่อผู้ใช้งาน" />)}
      </Form.Item>
      <Form.Item label="รหัสผ่าน" className="mb-0">
        {getFieldDecorator("password", {
          rules: [
            {
              required: true,
              message: "กรุณากรอกรหัสผ่าน",
            },
          ],
          initialValue: state.form.password,
        })(<Input.Password placeholder="รหัสผ่าน" />)}
      </Form.Item>
      <Form.Item label="ชื่อ" className="mb-0">
        {getFieldDecorator("first_name", {
          rules: [
            {
              required: true,
              message: "กรุณากรอกชื่อ",
            },
          ],
          initialValue: state.form.first_name,
        })(<Input placeholder="ชื่อ" />)}
      </Form.Item>
      <Form.Item label="นามสกุล" className="mb-0">
        {getFieldDecorator("last_name", {
          rules: [
            {
              required: true,
              message: "กรุณากรอกนามสกุล",
            },
          ],
          initialValue: state.form.last_name,
        })(<Input placeholder="นามสกุล" />)}
      </Form.Item>
      <Form.Item label="รหัสบัตรประชาชน" className="mb-0">
        {getFieldDecorator("id_card", {
          rules: [
            {
              required: false,
              asyncValidator: (rule, value) => {
                return new Promise((resolve, reject) => {
                  if (!rule.required && value?.length === 0) {
                    resolve();
                  }
                  let sum = 0;
                  if (value?.length !== 13) {
                    reject("กรุณาระบุเลขบัตรประชาชน 13 หลัก");
                  }
                  for (let i = 0; i < 12; i++) {
                    sum += parseFloat(value.charAt(i)) * (13 - i);
                  }
                  if ((11 - (sum % 11)) % 10 !== parseFloat(value.charAt(12))) {
                    reject("เลขบัตรประชาชนไม่ถูกต้อง");
                  } else {
                    resolve();
                  }
                });
              },
            },
          ],
          initialValue: state.form.id_card,
        })(<Input placeholder="รหัสบัตรประชาชน" />)}
      </Form.Item>
      <Form.Item label="เบอร์โทรศัพท์" className="mb-0">
        {getFieldDecorator("mobile", {
          rules: [
            {
              required: false,
              asyncValidator: (rule, value) => {
                return new Promise((resolve, reject) => {
                  if (!rule.required && value?.length === 0) {
                    resolve();
                  }

                  if (isNaN(value)) {
                    reject("กรุณากรอกเฉพาะตัวเลข");
                  } else {
                    resolve();
                  }
                });
              },
            },
          ],
          initialValue: state.form.mobile,
        })(<Input placeholder="เบอร์โทรศัพท์" />)}
      </Form.Item>

      <Form.Item label="อีเมล" className="mb-0">
        {getFieldDecorator("email", {
          initialValue: state.form.email,
        })(<Input placeholder="อีเมล" />)}
      </Form.Item>

      <Form.Item label="ที่อยู่" className="mb-0">
        <Row gutter={8}>
          <Col span={18}>
            {getFieldDecorator("address", {
              initialValue: state.form.address,
            })(<Input placeholder="ที่อยู่" />)}
          </Col>
          <Col span={6}>
            <Button
                type="danger"
                block
              onClick={() => {
                Modal.confirm({
                  title: "ยืนยันการล้างข้อมูลที่อยู่",
                  content:
                    "หากดำเนินการต่อ ข้อมูลที่อยู่ จังหวัด อำเภอ ตำบล และรหัสไปรษณีย์ จะถูกลบทั้งหมด",
                  okText: "ยืนยัน",
                  cancelText: "ยกเลิก",
                  onOk: () => {
                    form.setFieldsValue({
                      address: "",
                      province_id: undefined,
                      district_id: undefined,
                      sub_district_id: undefined,
                      post_code: undefined,
                    });

                    dispatch({
                      type: "SET_FORM_VALUE",
                      payload: {
                        address: "",
                        province_id: "",
                        district_id: "",
                        sub_district_id: "",
                        post_code: "",
                      },
                    });
                    return Promise.resolve();

                  },
                });
              }}
            >
              ลบข้อมูลที่อยู่
            </Button>
          </Col>
        </Row>
      </Form.Item>
      <Form.Item label="จังหวัด" className="mb-0">
        {getFieldDecorator("province_id", {
          initialValue: state.form.province_id,
          rules: [
            {
              required:
                getFieldValue("address") !== null &&
                getFieldValue("address") !== "",
              message: "กรุณาเลือก จังหวัด",
            },
          ],
          onChange: (e, option) => {
            form.setFieldsValue({
              province_id: e,
              district_id: undefined,
              sub_district_id: undefined,
              post_code: undefined,
            });
            dispatch({
              type: "SET_FORM_VALUE",
              payload: {
                province_id: e,
                province: option.props.source.name,
                district_id: "",
                sub_district_id: "",
                post_code: "",
              },
            });
          },
        })(
          <SelectAddressMaster
            size="small"
            className="w-100"
            type="province"
            showSearch
            placeholder="จังหวัด"
            filterOption={(input, option) =>
              option.props.children
                .toLowerCase()
                .indexOf(input.toLowerCase()) >= 0
            }
          />
        )}
      </Form.Item>
      <Form.Item label="เขต/อำเภอ" className="mb-0">
        {getFieldDecorator("district_id", {
          initialValue: state.form.district_id,
          rules: [
            {
              required:
                getFieldValue("address") !== null &&
                getFieldValue("address") !== "",
              message: "กรุณาเลือก เขต/อำเภอ",
            },
          ],
          onChange: (e, option) => {
            form.setFieldsValue({
              district_id: e,
              sub_district_id: undefined,
              post_code: undefined,
            });
            dispatch({
              type: "SET_FORM_VALUE",
              payload: {
                district_id: e,
                district: option.props.source.name,
                sub_district_id: "",
                post_code: "",
              },
            });
          },
        })(
          <SelectAddressMaster
            size="small"
            className="w-100"
            type="district"
            showSearch
            placeholder="เขต/อำเภอ"
            province_id={getFieldValue("province_id")}
          />
        )}
      </Form.Item>
      <Form.Item label="แขวง/ตำบล" className="mb-0">
        {getFieldDecorator("sub_district_id", {
          initialValue: state.form.sub_district_id,
          rules: [
            {
              required:
                getFieldValue("address") !== null &&
                getFieldValue("address") !== "",
              message: "กรุณาเลือก แขวง/ตำบล",
            },
          ],
          onChange: (e, option) => {
            form.setFieldsValue({
              sub_district_id: e,
              post_code: option.props.source.post_code,
            });
            dispatch({
              type: "SET_FORM_VALUE",
              payload: {
                sub_district_id: e,
                sub_district: option.props.source.name,
                post_code: option.props.source.post_code,
              },
            });
          },
        })(
          <SelectAddressMaster
            size="small"
            className="w-100"
            type="subdistrict"
            showSearch
            placeholder="แขวง/ตำบล"
            district_id={getFieldValue("district_id")}
          />
        )}
      </Form.Item>
      <Form.Item label="รหัสไปรษณีย์" className="mb-0">
        {getFieldDecorator("post_code", {
          initialValue: state.form.post_code,
          rules: [
            {
              required:
                getFieldValue("address") !== null &&
                getFieldValue("address") !== "",
              message: "กรุณากรอกรหัสไปรษณีย์",
            },
          ],
        })(<Input placeholder="รหัสไปรษณีย์" />)}
      </Form.Item>

      <Form.Item label="ตำแหน่ง" className="mb-0">
        {getFieldDecorator("position", {
          initialValue: state.form.position,
        })(
          <SelectPosition
            showSearch
            placeholder="-- เลือกตำแหน่ง --"
            filterOption={(input, option) =>
              option.props.children
                .toLowerCase()
                .indexOf(input.toLowerCase()) >= 0
            }
          />
        )}
      </Form.Item>
      <Form.Item label="สาขา" className="mb-0">
        {/* {getFieldDecorator("department", {
          initialValue: state.form.department,
        })(<SelectDepartment placeholder="-- เลือกแผนก --" />)} */}
        {
          _.find(state.form.branch || [], (n) => n.is_default === 1)
            ?.branch_name
        }
      </Form.Item>
      <Form.Item label="ฝ่าย" className="mb-0">
        {getFieldDecorator("division_id", {
          initialValue: state.form.division_id,
          onChange: (e) => {
            dispatch({ type: "SET_FORM_VALUE", payload: { division_id: e } });
            props.form.setFieldsValue({ department_id: "" });
          },
        })(<SelectDivision placeholder="-- เลือกฝ่าย --" />)}
      </Form.Item>
      <Form.Item label="แผนก" className="mb-0">
        {getFieldDecorator("department_id", {
          initialValue: state.form.department_id,
        })(
          <SelectDepartments
            division_id={state.form.division_id}
            placeholder="-- เลือกแผนก --"
          />
        )}
      </Form.Item>
      <Form.Item label="ระดับ" className="mb-0">
        {getFieldDecorator("rank", {
          initialValue: state.form.rank,
        })(
          <SelectAllType
            process_type="user_rank"
            className="w-100"
            withAll
            allText="-- เลือกระดับ --"
          />
        )}
      </Form.Item>
      <Form.Item label="สถานะ" className="mb-0">
        {getFieldDecorator("status", {
          initialValue: state.form.status ? state.form.status : "active",
        })(
          <Radio.Group>
            <Radio value="active">ใช้งาน</Radio>
            <Radio value="inactive">งดใช้งาน</Radio>
          </Radio.Group>
        )}
      </Form.Item>
    </Form>
  );
};

export default Form.create("user-form")(FormUser);
